/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HandlingUnitValidationModel} from './contracts/handling-unit-validation.model';
import {Observable} from 'rxjs';
import {HandlingUnitValidationResultModel} from './contracts/handling-unit-validation-result.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class HandlingUnitApi {
    private handlingUnitBaseUrl = `${environment.claimsBaseUrl}/api/handlingUnit`;
    private handlingUnitValidateUrl = `${this.handlingUnitBaseUrl}/validate`;

    constructor(private http: HttpClient) {
    }

    validateHandlingUnits(validationModel: HandlingUnitValidationModel):
            Observable<HandlingUnitValidationResultModel[]> {
        return this.http.post<HandlingUnitValidationResultModel[]>(this.handlingUnitValidateUrl, validationModel);
    }

    validateHandlingUnit(plantCode: string, materialNumber: string, partnerCode: string,
                         handlingUnit: string): Observable<HandlingUnitValidationResultModel> {
        return this.http.get<HandlingUnitValidationResultModel>(`${this.handlingUnitValidateUrl}?` + [
            `supplyingPackingPlantCode=${plantCode}`,
            `materialNumber=${materialNumber}`,
            `partnerCode=${partnerCode}`,
            `handlingUnit=${handlingUnit}`
        ].join('&'));
    }

}
